const stylo160Data = {
  slug: "stylo-160",
  name: "Honda Stylo 160",

  hero: {
    shortDescription:
      "Skutik premium retro-modern 160cc dengan desain elegan, mesin bertenaga, dan fitur keselamatan canggih",

    variants: [
      {
        key: "cbs-glam-black",
        label: "CBS",
        fullName: "New Honda Stylo 160 CBS Glam Black",
        startPrice: 29463000,
      },
      {
        key: "abs-royal-green",
        label: "ABS",
        fullName: "New Honda Stylo 160 ABS Royal Green",
        startPrice: 33217000,
      },
      {
        key: "abs-royal-matte-blue",
        label: "ABS",
        fullName: "New Honda Stylo 160 ABS Royal Matte Blue",
        startPrice: 33217000,
      },
    ],

    slides: [
      {
        variantKey: "cbs-glam-black",
        image: "/assets/motor/produk/stylo160/Stylo-160-CBS-Glam-Black.webp",
        specs: {
          engine: "156,9 cc",
          transmission: "Otomatis, V-Matic",
          feature: "CBS",
        },
      },
      {
        variantKey: "abs-royal-green",
        image: "/assets/motor/produk/stylo160/Stylo-160-ABS-Royal-Green.webp",
        specs: {
          engine: "156,9 cc",
          transmission: "Otomatis, V-Matic",
          feature: "ABS",
        },
      },
      {
        variantKey: "abs-royal-matte-blue",
        image: "/assets/motor/produk/stylo160/Stylo-160-ABS-Royal-Matte-Blue.webp",
        specs: {
          engine: "156,9 cc",
          transmission: "Otomatis, V-Matic",
          feature: "ABS",
        },
      },
    ],
  },

  description: {
    sections: [
      {
        type: "paragraph",
        text:
          "Honda Stylo 160 menghadirkan konsep skutik premium dengan desain retro-modern yang elegan dan eksklusif.",
      },
      {
        type: "paragraph",
        text:
          "Ditenagai mesin 160cc eSP+ 4 katup berpendingin cairan, Stylo 160 menawarkan performa halus namun bertenaga.",
      },
      {
        type: "heading",
        text: "Desain Retro Premium",
      },
      {
        type: "paragraph",
        text:
          "Sentuhan klasik berpadu dengan teknologi modern menciptakan tampilan yang berkelas.",
      },
      {
        type: "heading",
        text: "Performa & Kenyamanan",
      },
      {
        type: "paragraph",
        text:
          "Posisi berkendara ergonomis dan suspensi nyaman cocok untuk penggunaan harian maupun perjalanan jarak jauh.",
      },
    ],
  },

  specificationsDetail: {
    mesin: [
      ["Tipe Mesin", "4 Langkah, 4 Katup, eSP+"],
      ["Kapasitas Mesin", "156,9 cc"],
      ["Sistem Pendingin", "Liquid Cooled"],
      ["Sistem Suplai Bahan Bakar", "PGM-FI"],
      ["Daya Maksimum", "11,3 kW / 8.500 rpm"],
      ["Torsi Maksimum", "13,8 Nm / 7.000 rpm"],
      ["Transmisi", "Otomatis, V-Matic"],
    ],

    rangka: [
      ["Tipe Rangka", "Underbone"],
      ["Suspensi Depan", "Teleskopik"],
      ["Suspensi Belakang", "Suspensi Tunggal"],
      ["Rem Depan", "Cakram"],
      ["Rem Belakang", "Cakram"],
    ],

    dimensi: [
      ["Panjang x Lebar x Tinggi", "1.886 x 706 x 1.133 mm"],
      ["Jarak Sumbu Roda", "1.275 mm"],
      ["Tinggi Jok", "768 mm"],
      ["Berat", "118 kg (CBS) / 119 kg (ABS)"],
    ],

    kapasitas: [
      ["Kapasitas Tangki Bahan Bakar", "5,0 Liter"],
      ["Kapasitas Bagasi", "16,5 Liter"],
    ],

    kelistrikan: [
      ["Sistem Pengapian", "Full Transistorized"],
      ["Panel Meter", "Digital & Analog Combination"],
      ["Lampu", "Full LED"],
    ],
  },

  fullFeatures: {
    title: "Fitur Unggulan Honda Stylo 160",
    items: [
      {
        title: "Mesin 160cc eSP+",
        desc:
          "Performa halus, responsif, dan efisien untuk penggunaan harian.",
      },
      {
        title: "Desain Retro Modern",
        desc:
          "Tampilan klasik dengan sentuhan premium yang elegan.",
      },
      {
        title: "Sistem Pengereman ABS (Tipe ABS)",
        desc:
          "Kontrol pengereman lebih aman dan stabil.",
      },
      {
        title: "Smart Key System",
        desc:
          "Sistem keyless dengan alarm dan answer back system.",
      },
      {
        title: "Panel Meter Kombinasi",
        desc:
          "Informasi berkendara modern dan mudah dibaca.",
      },
      {
        title: "Lampu Full LED",
        desc:
          "Pencahayaan terang dan hemat energi.",
      },
    ],
  },
};

export default stylo160Data;
